<template>
    <div class="home">
      <DropZone :format="'ticketRepet'"/>
    </div>
  </template>
  
  <script>
    import DropZone from '../../components/dashboard/DropZone.vue'
  
    export default {
      name: 'RepeatTickets',
      components: {
        DropZone,
      },
    }
  </script>
  
  <style scoped>
  .home {
    height: calc(100vh - 62px);
    display: flex;
    justify-content: center;
    /* 
    align-items: center; */
    background-color: #FFF;
    overflow-x:hidden
    
  }
  </style>